import { css, html, nothing } from 'lit';
import { customElement, property, query } from 'lit/decorators.js';
import { levelHeaderStyles } from 'src/library/level-header-styles.js';
import { ResponsiveElement } from 'src/library/elements/responsive-container.js';
import type { IconEnum } from './icon-enum';
import { iconUrl } from 'src/store/utilities';

/**
 *
 * STATUS OK
 */
@customElement('d-page-header')
export class DPageHeader extends ResponsiveElement {
  static readonly styles = [
    levelHeaderStyles,
    css`
      :host {
        background: var(--backgroundGray);
        border-top-left-radius: 12px;
        border: 1px solid transparent;
      }
      .header {
        border-bottom: 1px solid var(--borderColorOnGray);
        background-color: var(--backgroundGray);
      }
      .sublabel {
        font-weight: 400;
        font-size: max(80%, 15px);
      }
    `,
  ];
  @property({ type: String })
  icon: IconEnum = '';
  @property({ type: String })
  label = '';
  @property({ type: String })
  sublabel = '';
  @property({ type: String })
  href = '';
  @property({ type: Boolean, reflect: true })
  covered = false;
  @property({ type: Boolean })
  top = false;
  @query('.header')
  private _headerEl?: HTMLDivElement;

  private get titleStyle() {
    if (this.icon && this.icon !== 'robot') {
      return 'background-image: ' + iconUrl(this.icon, 'color');
    }
    return '';
  }

  private get titleClass() {
    if (this.icon) {
      if (this.icon === 'robot') {
        return 'title icon robot';
      }
      return 'title icon';
    }
    return 'title';
  }

  onResize() {
    if (this._headerEl) {
      const height = this._headerEl.clientHeight;
      this.dispatchEvent(
        new CustomEvent('height-changed', {
          bubbles: true,
          composed: true,
          detail: height,
        }),
      );
    }
  }

  render() {
    return html`
      <div class="header">
        <div class="actions">
          <slot></slot>
        </div>
        <div style="${this.titleStyle}" class="${this.titleClass}">
          <span class="name">${this.label}</span>
          ${!this.sublabel ? nothing : html` <span class="sublabel">${this.sublabel}</span> `}
          ${this.covered ? html`<a class="header-link" href="${this.href}"></a>` : nothing}
        </div>
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'd-page-header': DPageHeader;
  }
}
